import { DialogModule } from 'primeng/dialog';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { CommonModule, DOCUMENT } from '@angular/common';
import { GenericButtonComponent } from '../../../../global/component/generic/generic-button/generic-button.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { Table, TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { InputTextModule } from 'primeng/inputtext';
import { FormControl, FormsModule } from '@angular/forms';
import { MenuItem, MessageService, SelectItem } from 'primeng/api';
import { GenericTextInputComponent } from '../../../../global/component/generic/generic-text-input/generic-text-input.component';
import { InputGroupModule } from 'primeng/inputgroup';
import { MenuModule } from 'primeng/menu';
import { ToastModule } from 'primeng/toast';
import { LoadingSpinnerComponent } from '../../../../global/component/loading-spinner/loading-spinner.component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { Router } from '@angular/router';
import { MatchType } from '../../../../global/model/search/MatchType';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MainModel } from '../../../../global/model/MainModel';
import { Component, Inject, Input, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { SearchModel, DisplayColumn, LookupItem, LookupFilter, FilterModel } from '../../../../global/model/SearchModel';
import { SearchService } from '../../../../global/services/data/search-service/searchservice';
import { ExpenseAddStepperComponent } from '../../expenses-add/Stepper/expense-add-stepper.component';
import { catchError, forkJoin, map, of, Subscription } from 'rxjs';
import { ExportColumn } from '../../../../global/model/ExportColumn';
import { AddExpenseService } from '../../../services/add-expense.service';
import { TableFilterComponent } from "../../../../../../src/app/global/component/generic/table-filter/table-filter.component";
import { CalendarModule } from 'primeng/calendar';
import { VendorW9ViewModel } from '../../../models/VendorViewModel';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import Campaign from '../../../../global/model/Campaign';
import { exportToExcel } from '../../../../global/util/util';

@Component({
  selector: 'app-expense-search-mobile',
  standalone: true,
  imports: [DialogModule, ExpenseAddStepperComponent, CommonModule, TableModule, CommonModule, ButtonModule, DialogModule, FormsModule, MultiSelectModule, ToggleButtonModule, MenuModule, GenericButtonComponent, ToastModule,
    TagModule, InputGroupModule, InputIconModule, IconFieldModule, CardModule, GenericTextInputComponent, LoadingSpinnerComponent, OverlayPanelModule,
    InputTextModule, TableFilterComponent, CalendarModule, CheckboxModule, DropdownModule],
  providers: [MessageService],
  templateUrl: './expense-search-mobile.component.html',
  styleUrl: './expense-search-mobile.component.scss'
})

export class ExpenseSearchMobileComponent implements OnInit, AfterViewInit {
  @ViewChild('resultTable')
  resultTable!: Table;
  // Arrays
  typeFilter: any[] = [];
  defaultColumns: DisplayColumn[] = [];
  selectedColumns: DisplayColumn[] = [];
  exportColumns: ExportColumn[] = [];
  lkpCheckboxes: LookupItem[] = [];
  groupedOptions: any[] = [];
  tableData: any[] = [];
  selectedOptions: MenuItem[] = [];
  dataElements: any[] = [];
  selectedCheckbookIds: number[] = [];
  filters: string[] = [];
  selectedRows: any[] = [];
  approvalsData: any[] = [];
  selectedStatuses: string[] = [];
  selectedFundCodes: number[] = [];
  checkedColumns: DisplayColumn[] = [];
  numberOfItemsSelected: number = 0;
  selectedapproval: string = '2';
  selectedHold: string = 'All';
  dialogMessage = "";
  dialogData: any = null;
  dialogAcceptCallback: (() => void) | null = null;
  dialogRejectCallback: (() => void) | null = null;

  holdOptions: LookupItem[] = [
    { key: 2, value: 'All' },
    { key: 1, value: 'Yes' },
    { key: 0, value: 'No' }
  ];

  // Booleans
  isExpanded = false;
  showLoading: boolean = false;
  isFullscreen: boolean = false;
  balanceFrozen: boolean = true;
  showScrollFilters: boolean = false;
  showDialog: boolean = false;
  campaignId!: number;
  maxSelectedLabels = this.isExpanded ? 100 : 10;
  selectedExpenseId!: number;
  allItemsChecked: boolean = false;
  dialogVisible = false;

  expenseId: number = 0;

  // Objects
  textFilters: { [key: string]: string } = {};
  columnData: SearchModel = {
    displayColumns: [],
    states: [],
    fundCodes: [],
    commonFilters: [],
    textFilters: [],
    rangeFilters: [],
    amountFilters: [],
    statusOptions: [],
    approvalOptions: [],
    fundraisers: [],
    sources: [],
    events: [],
    checkbooks: [],
    dateFilters: [],
    batchTypes: []
  };

  // Angular Specific (Decorators, Observables, Inputs/Outputs)
  subscription: Subscription = new Subscription();

  @Input() searchKeyword: string = '';
  @Input() showInDialog: boolean = false;

  // Form Controls
  filterValue: FormControl = new FormControl('');

  // Other / Miscellaneous
  cols!: DisplayColumn[];
  defaultCmmonFilters: SelectItem[] = [];
  NoDataMessage: string = "Use Quick Search or adjust filters above to find Expenses.";
  compareEnabled: boolean = false;
  showAddNewExpenseDialog = false;
  activeIndex = 0;

  constructor(private expenseService: AddExpenseService,
    private messageService: MessageService,
    private searchService: SearchService,
    private mainModel: MainModel,
    private router: Router,
    private cdr: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: Document) {

  }
  ngOnDestroy(): void {
  }
  ngOnInit(): void {
    this.selectedOptions = [
      { label: 'Approve My Expenses', icon: 'fa-sharp fa-light fa-user-check', command: () => this.approveSelected() },
      { label: 'Send for Payment', icon: 'fa-sharp fa-light fa-envelope-open-dollar', command: () => this.sendForPaymentSelected() },
      { label: 'Delete', icon: 'fa-sharp fa-light fa-trash-can', command: () => this.deleteSelected() }
    ];
    const c: any = this.mainModel.selectedCampaign();
    this.campaignId = parseInt(c?.campaignId);
    if (!this.campaignId) {
      this.GetCampaignId();
    }
    else {
      this.loadColumns();
    }
    this.filterValue.setValue(this.searchKeyword);
  }

  private GetCampaignId() {
    this.mainModel.fetchSelectedCampaign().subscribe({
      next: (campaign: Campaign) => {
        this.mainModel.setSelectedCampaign(campaign);
        this.campaignId = campaign.campaignId;
        this.loadColumns();
      },
      error: (err) => {
        console.error('Failed to fetch selected campaign:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to fetch the selected campaign. Please try again later.',
          life: 5000,
        });
      },
    });
  }
  GetCampaignIdAndSearch() {
    this.mainModel.fetchSelectedCampaign().subscribe({
      next: (campaign: Campaign) => {
        this.mainModel.setSelectedCampaign(campaign);
        this.campaignId = campaign.campaignId;
        this.selectedStatuses = ["Unapproved", "Approved", "Partial"]
        // Filter the table using values, not keys
        this.resultTable.filter(this.selectedStatuses, 'ExpenseStatus', 'in');
        this.resultTable.filter(null, 'AssignedToCurrentUser', 'equals');
        this.onSearch();
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Failed to fetch selected campaign:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to fetch the selected campaign. Please try again later.',
          life: 5000,
        });
      },
    });
  }

  ngAfterViewInit() {
    if (this.campaignId) {
      this.selectedStatuses = ["Unapproved", "Approved", "Partial"]
      // Filter the table using values, not keys
      this.resultTable.filter(this.selectedStatuses, 'ExpenseStatus', 'in');
      this.resultTable.filter(null, 'AssignedToCurrentUser', 'equals');
      this.onSearch();
      this.cdr.detectChanges();
    }
    else {
      this.GetCampaignIdAndSearch();
    }
  }


  check(i: DisplayColumn) {
    this.howManyChecked();
    if (this.numberOfItemsSelected === this.tableData.length) {
      this.allItemsChecked = true;
    } else {
      this.allItemsChecked = false;
    }
  }

  approveSelected() {
    const skippedRecords: { requestId: number; reason: string }[] = [];
    var checkedData = this.tableData.filter(row => row.isChecked);
    const approvedRecords = checkedData.filter(row => row.AssignedToCurrentUser === '1' && row['MyApproval'] === '0').map(row => row.ExpenseRequestId);
     checkedData
      .filter(row => (row.AssignedToCurrentUser === '1' && row['MyApproval'] !== '0') || row['MyApproval'] === "")
      .forEach(row => {
        skippedRecords.push({
          requestId: row.ExpenseRequestId,
          reason: 'Not Assigned to User or Approved'
        });
      });
    this.dialogVisible = true;

    const approvedMessage = `Are you sure you want to approve selected expense request(s): ${approvedRecords.join(',')}? \n\n`;
    const unapprovedMessage = `The following request(s) will be skipped as they do not require your approval: ${skippedRecords.join(',')}`;
    let message;

    if (approvedRecords.length > 0) {
      if (skippedRecords.length === 0) {
        message = approvedMessage;
      }
      else {
        message = approvedMessage + unapprovedMessage;
      }
    }
    else {
      message = unapprovedMessage;
    }

    this.confirmAction(
      {
          approved: {
            message: 'Are you sure you want to approve selected expense request(s):',
            records: approvedRecords.map(r => r).join(', ')
          },
          skipped: {
            message: 'The following request(s) will be skipped as they do not require your approval:',
            records: skippedRecords
          }
        },
      () => {
        if (approvedRecords.length > 0) {
          this.expenseService.expenseRequestApprovemulti(approvedRecords).subscribe({
            next: () => {
              this.onSearch();
              this.cdr.detectChanges();
              this.howManyChecked();
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully Approved Expense Request(s)!' });
            },
            error: () => {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to Approved Expense Request(s)!' });
            }
          });
        }
      },
      () => {
        this.dialogVisible = false;
      }
    );
  }

  sendForPaymentSelected() {
    const checkedData = this.tableData.filter(row => row.isChecked);
    const skippedRecords: { requestId: number; reason: string }[] = [];
    // Split approved and skipped initially based on status
    const approvedRows = checkedData.filter(row => row.ExpenseStatus === 'Approved');
    checkedData
      .filter(row => row.ExpenseStatus !== 'Approved')
      .forEach(row => {
        skippedRecords.push({
          requestId: row.ExpenseRequestId,
          reason: 'Not Approved'
        });
      });

    // For all approved rows, fetch details in parallel
    const detailRequests = approvedRows.map(row =>
      this.expenseService.getExpenseDetails(row.ExpenseRequestId).pipe(
        map(details => ({
          row,
          details,
          match: details.calculatedAmount === parseFloat(row.ExpenseAmount)
        })),
        catchError(err => {
          console.error(`Failed to fetch for ${row.ExpenseRequestId}`, err);
          return of({ row, details: null, match: false }); // Treat error as mismatch
        })
      )
    );

    forkJoin(detailRequests).subscribe(results => {
      const finalApprovedRecords: number[] = [];

      results.forEach(({ row, match }) => {
        if (match) {
          finalApprovedRecords.push(row.ExpenseRequestId);
        } else {
          skippedRecords.push({
            requestId: row.ExpenseRequestId,
            reason: "Request Amount doesn't match the calculated Amount"
          });
        }
      });

      this.dialogVisible = true;

      this.confirmAction(
        {
          approved: {
            message: 'Are you sure you want to send for payment selected expense request(s):',
            records: finalApprovedRecords.map(r => r).join(', ')
          },
          skipped: {
            message: 'The following request(s) will be skipped for the following reason(s):',
            records: skippedRecords
          }
        },
        () => {
          if (finalApprovedRecords.length > 0) {
            this.expenseService.expenseRequestSendForPaymentMulti(finalApprovedRecords).subscribe({
              next: () => {
                this.onSearch();
                this.cdr.detectChanges();
                this.howManyChecked();
                this.messageService.add({
                  severity: 'success',
                  summary: 'Success',
                  detail: 'Successfully Sent for Payment ExpenseRequest(s)!'
                });
              },
              error: () => {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'Failed to Send for Payment ExpenseRequest(s)!'
                });
              }
            });
          }
        },
        () => {
          this.dialogVisible = false;
        }
      );
    });
  }

  deleteSelected() {
    var checkedData = this.tableData.filter(row => row.isChecked);
    const unapprovedRecords = checkedData.map(row => row.ExpenseRequestId);
    this.dialogVisible = true;
    let message = `Are you sure you want to delete expense request(s): ${unapprovedRecords.join(',')}?`;
    this.confirmAction(
      {
        approved: {
          message: 'Are you sure you want to delete expense request(s):',
          records: unapprovedRecords.join(',')
        },
      },
      () => {
        this.expenseService.deleteMultipleExpenseRequest(unapprovedRecords).subscribe({
          next: () => {
            this.onSearch();
            this.cdr.detectChanges();
            this.howManyChecked();
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully Deleted Expense Request!' });
          },
          error: () => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to Delete Expense Request!' });
          }
        });
      },
      () => {
        this.dialogVisible = false;
      }
    );
  }

  checkAll() {
    this.tableData.forEach(
      (i: DisplayColumn) => {
        i.isChecked = this.allItemsChecked;
      }
    );
    if (!this.allItemsChecked) {
      this.numberOfItemsSelected = 0;
    } else {
      this.numberOfItemsSelected = this.tableData.length;
    }
  }

  getChecked() {
    this.checkedColumns = this.tableData.filter(
      (i: DisplayColumn) => i.isChecked
    );
    return this.checkedColumns;
  }

  howManyChecked() {
    this.numberOfItemsSelected = this.getChecked().length;
    return this.numberOfItemsSelected;
  }

  //#region onExportToExcel Click
  onExportToExcel() {
    const fields = this.selectedColumns.map(col => col.columnName);
    const dataToExport = this.resultTable.value.map(row => {
      const filteredRow: any = {};
      fields.forEach(field => {
        const value = row[field];
        filteredRow[field] = value !== undefined && value !== null ? value : '';
      });
      return filteredRow;
    });
    exportToExcel(dataToExport,"Expense Search");
  }
  //#endregion

  // Range Filters Code
  getBlankFilter(obj: any): FilterModel {
    let filterModel: FilterModel = new FilterModel();
    //filterModel.from = "";
    filterModel.op = "contains";
    if (obj.displayColumnType.columnType === "AmountFilter" ||
      obj.displayColumnType.columnType === "DateFilter") {
      filterModel.ops = [
        { label: 'Equals', value: 'Equals' },
        { label: 'Greater Than', value: 'gt' },
        { label: 'Greater Than Or Equal To', value: 'gte' },
        { label: 'Less Than', value: 'lt' },
        { label: 'Less Than Or Equal To', value: 'lte' },
        { label: 'Between', value: 'between' }
      ];
      filterModel.options = obj.options || [];
      filterModel.dataType = obj.displayColumnType.columnType === 'DateFilter' ? "date" : "number";

      delete obj.options;
      return filterModel as FilterModel;
    }
    return filterModel;
  }

  updateFilter(ref: any, att: string, val: any) {
    ref.filterModel[att] = (val.value ? val.value : val);
  }

  hideAllOpenOpMenus() {
    this.selectedColumns.forEach(
      (i: DisplayColumn) => {
        i.filterModel.isMenuOpen = false;
      }
    );
  }

  toggleMenu(col: DisplayColumn) {
    if (col.filterModel.isMenuOpen === false) {
      this.hideAllOpenOpMenus();
    }
    col.filterModel.isMenuOpen = !col.filterModel.isMenuOpen;
  }

  popupMenuClickHandler(col: DisplayColumn, op: any) {
    col.filterModel.op = op.value;
    if (col.filterModel.op !== 'between') { col.filterModel.isMenuOpen = false }
  }
  loadColumns() {
    this.expenseService.getExpenseSearchColumnsAndFilters(this.campaignId).subscribe({
      next: (data: SearchModel) => {
        this.columnData = data;
        this.defaultColumns = data && data.displayColumns ? data.displayColumns : [];
        if (this.defaultColumns)
          this.groupedOptions = this.groupColumnsBy('groupByColumn');
        this.selectedColumns = data && data.displayColumns ? data.displayColumns.filter(x => x.isDefault) : [];
        data.displayColumns.forEach((i: DisplayColumn) => {
          i.filterModel = this.getBlankFilter(i);
        });
        this.cols = this.selectedColumns || [];
        this.exportColumns = this.cols.map((col: any) => ({ title: col.header, dataKey: col.field }));
      },
      error: (err) => {
        console.error('Error loading expenses columns:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `Error loading expenses columns: ${err}`,
        });
      }
    });
  }

  groupColumnsBy(groupByField: keyof DisplayColumn) {
    const groups: any = {};
    this.defaultColumns.forEach(column => {
      const group = column[groupByField] as string;
      if (!groups[group]) {
        groups[group] = [];
      }
      groups[group].push(column);
    });

    return Object.keys(groups).map(group => ({
      label: group,
      items: groups[group]
    }));
  }

  hasNoResults = () => !this.tableData || this.tableData.length === 0;

  onGlobalFilter(event: Event, table: any) {
    const input = event.target as HTMLInputElement;
    table.filterGlobal(input.value, 'contains');
  }

  onPageSearch() {
    if (!this.filterValue?.value?.trim()) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please enter a keyword.',
      });
    }
    else {
      this.onSearch();
      this.cdr.detectChanges();
    }
  }

  getMatchMode(columnType: string): string {
    if (columnType === "TextFilter" || columnType === "IDFilter")
      return 'equals';
    if (columnType === "AmountFilter")
      return 'gt';
    else
      return 'startsWith'
  }

  toggleSelectedLabels() {
    this.isExpanded = !this.isExpanded;
    this.maxSelectedLabels = this.isExpanded ? 100 : 10;
    this.selectedColumns = [...this.selectedColumns];
  }

  pageForward() {
    (this.document.getElementsByClassName("p-paginator-next")[0] as HTMLAnchorElement).click()
  }

  pageBack() {
    (this.document.getElementsByClassName("p-paginator-prev")[0] as HTMLAnchorElement).click()
  }

  resetFilters() {

    this.resultTable.clear();
    this.textFilters = {};
    this.selectedRows = [];
    this.tableData = [];
    this.selectedStatuses = [];
    this.selectedapproval = '2';
    this.selectedFundCodes = [];
    this.selectedHold = 'All';
    this.selectedCheckbookIds = [];
    this.NoDataMessage = "Use Quick Search or adjust filters above to find Expenses.";
    this.selectedColumns.forEach((i: DisplayColumn) => {
      i.filterModel = this.getBlankFilter(i);
    });
    this.filterValue.patchValue(null);
    this.selectedStatuses = ["Unapproved", "Approved", "Partial"];
    this.resultTable.filter(this.selectedStatuses, 'ExpenseStatus', 'in');
  }

  private loadFilteredData(campaignId: number, filterData: string) {
    this.showLoading = true;
    this.tableData = [];
    this.expenseService.searchExpenses(campaignId,filterData, this.filterValue?.value ?? null).subscribe({
      next: (data: any[] | null = null) => {
        this.showLoading = false;
        if (data && data.length > 0) {
          const records: Array<{ [key: string]: string }> = data;
          if (Object.values(records[0]).every(value => value.trim() === "")) {
            this.NoDataMessage = "No results available. Please adjust filters and try again.";
            data = null;
            this.tableData = [];
          }
          else
            this.tableData = data;
        }
      },
      error: (error) => {
        this.showLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'An error occurred while fetching data.',
          life: 7500
        });
      }
    });
  }

  private buildFilterData(filters: { [key: string]: any }): string {

    if (this.selectedCheckbookIds && this.selectedCheckbookIds.length > 0) {
      filters['Checkbooks'] = {
        values: this.selectedCheckbookIds
      };
    }
    else {
      filters['Checkbooks'] = { values: [] };
    }

    if (this.selectedFundCodes && this.selectedFundCodes.length > 0) {
      filters['FundCodes'] = {
        values: this.selectedFundCodes
      };
    }
    else {
      filters['FundCodes'] = { values: [] };
    }
    // Text Filter
    for (const key in this.textFilters) {
      if (this.textFilters[key]?.trim()) {
        filters[key] = {
          value: this.textFilters[key].trim(),
          matchMode: 'contains'
        };
      } else {
        filters[key] = {
          value: null,
          matchMode: 'contains'
        };
      }
    }

    // Range Filter
    this.selectedColumns.forEach(
      (item: DisplayColumn) => {
        const { filterModel } = item;
        const isEmpty =
          filterModel.from === null ||
          filterModel.from === undefined ||
          (typeof filterModel.from === 'string' && filterModel.from.trim() === '') ||
          (Array.isArray(filterModel.from) && filterModel.from.length === 0);

        if (!isEmpty) {
          const filter: MatchType = new MatchType();
          filter.Value = filterModel.from;
          filter.MatchMode = filterModel.op;

          if (filterModel.to !== null && filterModel.to !== undefined && filterModel.to !== '') {
            filter.RangeEnd = filterModel.to;
          }

          filters[item.columnName] = filter;
        }
        else if (filters[item.columnName] && filters[item.columnName].matchMode?.length) {
          console.debug(filters[item.columnName]);
        }
        else {
          delete filters[item.columnName];
        }
      }
    )

    return JSON.stringify(filters);
  }

  onSearch() {
    this.showLoading = true;
    this.selectedRows = [];
    this.compareEnabled = false;
    const filterData = this.buildFilterData(this.resultTable.filters);
    this.loadFilteredData(this.campaignId, filterData);
  }

  onAddExpense(): void {
    this.selectedExpenseId = 0;
    this.expenseId = 0;
    this.showAddNewExpenseDialog = true;
  }

  onExpenseSelected(id: number) {
    this.expenseId = id;
  }

  onExpenseDialogOpened() {
    this.activeIndex = 0;
  }

  onExpenseDialogClosed() {
    this.activeIndex = 0;
    this.showAddNewExpenseDialog = false;
    this.searchService.emitCloseExpenseModal();
  }

  onCloseStepperDialog() {
    this.showAddNewExpenseDialog = false;
    this.onSearch();
  }
  onTableFilter(e: any) {
    const filters = this.resultTable.filters;
  }
  getSeverityAndValue(status: string): { severity: 'success' | 'secondary' | 'info' | 'warning' | 'danger' | 'contrast', value: string } {
    let severity: 'success' | 'secondary' | 'info' | 'warning' | 'danger' | 'contrast' | 'secondary'; // default value
    let value = status;
    switch (status) {
      case 'Unapproved':
        severity = "danger";
        value = 'Unapproved';
        break;
      case 'Partial':
        severity = 'warning';
        value = 'Partial';
        break;
      case 'Approved':
        severity = 'success';
        value = 'Approved';
        break;
      case 'Paid':
        severity = 'info';
        value = 'Paid';
        break;
      default:
        severity = 'secondary';
        value = 'Unknown';
    }
    return { severity, value };
  }

  getApprovalById(requestId: number, event: Event, overlay: any) {
    const params = {
      requestId: requestId,
    };
    this.showLoading = true;
    this.approvalsData = [];
    this.expenseService.getApprovers(requestId).subscribe({
      next: (data: any[]) => {
        this.showLoading = false;
        this.approvalsData = data.map(item => ({
          approvedBy: item.assignedApproverName,
          status: item.status,
          approvedDate: item.approvedDate ? new Date(item.approvedDate) : null
        }));
        overlay.toggle(event);
      },
      error: (error) => {
        this.showLoading = false;
        console.error("API Error:", error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Unable to retrieve approval data. Please try again later.',
          life: 7500
        });
      }
    })

  }

  onDownloadAttachement(attachment: VendorW9ViewModel, event: MouseEvent) {
    event.preventDefault();
    this.expenseService.downloadAttachement(attachment.fileName).subscribe({
      next: (blob) => {
        const a = document.createElement('a');
        const url = URL.createObjectURL(blob);
        a.href = url;
        a.download = attachment.fileName;
        a.click();
        URL.revokeObjectURL(url);
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Download File Failed!' });
      },
    });
  }

  openExistingExpense(expenseId: number): void {
    this.expenseId = expenseId;
    this.selectedExpenseId = expenseId;
    this.showAddNewExpenseDialog = true;
  }
  getShortAttachmentList(rowdata: any): string {
    const attachments = rowdata?.Attachments || [];
    const names = attachments.map((a: any) => a.fileName);
    const shortList = names.slice(0, 2).join(', ');
    return attachments.length > 2 ? shortList + '...' : shortList;
  }
  confirmAction(
    message: any,
    acceptCallback: () => void,
    rejectCallback?: () => void
  ) {
    if (typeof message === 'string') {
      this.dialogMessage = message;
      this.dialogData = null;
    }
    else {
      this.dialogMessage = "";
      this.dialogData = message;
    }
    this.dialogAcceptCallback = acceptCallback;
    this.dialogRejectCallback = rejectCallback || null;
    this.dialogVisible = true;
  }

  onDialogAccept() {
    this.dialogVisible = false;
    this.dialogAcceptCallback?.();
  }

  onDialogReject() {
    this.dialogVisible = false;
    this.dialogRejectCallback?.();
  }

  deleteExpenseRequest(expenseRequestId: number) {
    this.dialogVisible = true;
    this.confirmAction(
      `Are you sure you want to delete expense request:  ${expenseRequestId}?`,
      () => {
        this.expenseService.deleteExpenseRequest(expenseRequestId).subscribe({
          next: () => {
            this.onSearch();
            this.cdr.detectChanges();
            this.howManyChecked();
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully Deleted Exepense!' });
          },
          error: () => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to Delete ExpenseRequest!' });
          }
        });
      },
      () => {
        this.dialogVisible = false;
      }
    );
  }

  expenseRequestApprove(expenseRequestId: number) {
    this.dialogVisible = true;
    this.confirmAction(
      `Are you sure you want to approve expense request:  ${expenseRequestId}?`,
      () => {
        this.expenseService.expenseRequestApprove(expenseRequestId).subscribe({
          next: () => {
            this.onSearch();
            this.cdr.detectChanges();
            this.howManyChecked();
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully Approved Exepense!' });
          },
          error: () => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to Approve ExpenseRequest!' });
          }
        });
      },
      () => {
        this.dialogVisible = false;
      }
    );
  }

  sendforPayment(rowData: any) {
    this.expenseService.getExpenseDetails(rowData.ExpenseRequestId).subscribe({
      next: (details) => {
        if (details.calculatedAmount === parseFloat(rowData.ExpenseAmount)) {
          this.dialogVisible = true;
          this.confirmAction(
            `Are you sure you want to send for payment following request:  ${rowData.ExpenseRequestId}?`,
            () => {
              this.expenseService.expenseRequestSendForPayment(rowData.ExpenseRequestId).subscribe({
                next: () => {
                  this.onSearch();
                  this.cdr.detectChanges();
                  this.howManyChecked();
                  this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully Sent for Payment!' });
                },
                error: () => {
                  this.dialogVisible = false;
                  this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to Sent for Payment!' });
                }
              });
            },
            () => {
              this.dialogVisible = false;
            }
          );
        }
        else {
          this.dialogVisible = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: `The line item amount (${details.calculatedAmount}$) does not match the requested amount (${parseFloat(rowData.ExpenseAmount)}$), Please fix the error(s) and try again.` });
        }
      }, error: () => {
        this.dialogVisible = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to get calculated amount!' });
      }
    });
  }

  unapprovePayment(rowData: any) {
    this.expenseService.getExpenseDetails(rowData.ExpenseRequestId).subscribe({
      next: (details) => {
        if (details.calculatedAmount === parseFloat(rowData.ExpenseAmount)) {
          this.dialogVisible = true;
          this.confirmAction(
            `Are you sure you want to unapprove payment following request:  ${rowData.ExpenseRequestId}?`,
            () => {
              this.expenseService.expenseRequestUnApprove(rowData.ExpenseRequestId).subscribe({
                next: () => {
                  this.onSearch();
                  this.cdr.detectChanges();
                  this.howManyChecked();
                  this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully Unapproved Payment!' });
                },
                error: () => {
                  this.dialogVisible = false;
                  this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to Unapprove Payment!' });
                }
              });
            },
            () => {
              this.dialogVisible = false;
            }
          );
        }
        else {
          this.dialogVisible = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: `The line item amount (${details.calculatedAmount}$) does not match the requested amount (${parseFloat(rowData.ExpenseAmount)}$), Please fix the error(s) and try again.` });
        }
      }, error: () => {
        this.dialogVisible = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to get calculated amount!' });
      }
    });
  }

  getGroupIcon(status: string): string {
    switch (status) {
      case 'Paid':
      case 'Approved':
        return 'fa-sharp fa-solid fa-people-group redwood-60';
      case 'Partial':
        return 'fa-sharp fa-light fa-people-group redwood-60';
      case 'Unapproved':
        return 'fa-sharp fa-light fa-people-group neutral-20';
      default:
        return 'pi pi-question-circle'; // fallback icon
    }
  }
  getSeverity(status: string): 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'help' | 'danger' | 'contrast' | null {
    switch (status) {
      case 'Paid':
        return 'success';
      case 'Approved':
        return 'info';
      case 'Partial':
        return 'warning';
      case 'Unapproved':
        return 'secondary'; // gray-ish
      default:
        return null;
    }
  }

  onApprovalChange(filterCallback: (value: any) => void): void {
    if (this.selectedapproval === '2') {
      // "All" selected — clear the filter
      filterCallback(null);
    } else {
      // Apply filter normally
      filterCallback(this.selectedapproval);
    }
  }

  onHoldChange(filterCallback: (value: any) => void): void {
    if (this.selectedHold === 'All') {
      filterCallback(null); // Clear filter to show all
    } else {
      filterCallback(this.selectedHold);
    }
  }

  onCheckbookChange(selectedValues: number[], filterCallback: (val: any) => void) {
    const selectedKeys = this.columnData.checkbooks
      .filter(cb => selectedValues.includes(cb.key as number))
      .map(cb => cb.value);

    filterCallback(selectedKeys);
  }

  onFundChange(selectedValues: number[], filterCallback: (val: any) => void) {
    const selectedKeys = this.columnData.fundCodes
      .filter(cb => selectedValues.includes(cb.key as number))
      .map(cb => cb.value);

    filterCallback(selectedKeys);
  }
}
